/**
 * Keys for the signed-in session's queries. `authenticated()` holds the account,
 * user and workspaces `useAuthQuery` loads, which the auth store mirrors.
 */
export const authKeys = {
  authenticated: () => ['authenticated'] as const,
};
